import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { Button } from "semantic-ui-react";
import styles from "./LicenseData.module.scss";
import { PdApiActions, pdApiActions } from "../../../actions/pdApiActions";
import {hasWriteAccess } from "../../../utils/utils";


type LicenseState = {};

type StateProps = {
  pdApi: State.PdApi;
  isGeneratingLicense: boolean;
  activeUser: Api.User | undefined;
};

type DispatchProps = {
  pdApiActions: typeof pdApiActions;
};

export type PublishProps = StateProps & DispatchProps;

export class LicenseData extends React.Component<PublishProps, LicenseState> {

  render(): JSX.Element {
    const { isGeneratingLicense, activeUser } = this.props;
    return (
      <div className={styles.containerWithPadding}>
        <h2>Generate License Data</h2>
        <Button
          id="GenerateLicenseDataButton"
          className={styles.LicenseData}
          onClick={() => {
            this.setState(prevState => ({
              ...prevState,
              isGeneratingLicenseData: true
            }));
            this.props.pdApiActions.generateLicenseData();
          }}
          disabled={isGeneratingLicense || !hasWriteAccess(activeUser, "Lift")}
        >
          Generate Lift License
        </Button>
        <Button className={styles.LicenseData}
          onClick={() => {
                this.setState(prevState => ({
                  ...prevState,
                  isGeneratingLicenseData: true
                }));
                this.props.pdApiActions.generateEscalatorLicenseData();
              }}
          disabled={isGeneratingLicense || !hasWriteAccess(activeUser,"Escalator")}
        >
          Generate Escalator License
        </Button>
        <Button className={styles.LicenseData}
          onClick={() => {
                this.setState(prevState => ({
                  ...prevState,
                  isGeneratingLicenseData: true
                }));
                this.props.pdApiActions.generateDoorLicenseData();
              }}
          disabled={isGeneratingLicense || !hasWriteAccess(activeUser,"Door")}
        >
          Generate Door License
        </Button>
      </div>
    );
  }
}

const mapStateToProps = (state: State.Root) => ({
  pdApi: state.pdApi,
  isGeneratingLicense: state.licenseGenerationStatus.isGeneratingLicense
});

const mapDispatchToProps = (dispatch: Dispatch<PdApiActions>) => ({
  pdApiActions: bindActionCreators({ ...pdApiActions }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(LicenseData);

